import { createStore } from 'redux'

const toggleinitialState = {
  sidebarShow: false,
}

const changeState = (state = toggleinitialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
